import {
  Box,
  Button,
  Divider,
  Flex,
  Heading,
  List,
  ListIcon,
  ListItem,
  Stack,
  Text,
  useColorModeValue,
  useMediaQuery,
  Center,
  Badge,
} from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';

import { Link } from 'react-router-dom';


const options = [
  { id: 1, desc: '1 lorem ipsum' },
  { id: 2, desc: 'Lorem, ipsum dolor.' },
  { id: 3, desc: 'Monthly Updates' },
];

interface PackageTierProps {
  title: string;
  options: Array<{ id: number; desc: string }>;
  typePlan: string;
  checked?: boolean;
  productLink: string;
}

const PackageTier = ({
  title,
  options,
  typePlan,
  checked = false,
  productLink,
}: PackageTierProps) => {
  const colorTextLight = checked ? 'white' : 'purple.600';
  const bgColorLight = checked ? 'purple.400' : 'gray.300';

  const colorTextDark = checked ? 'white' : 'purple.500';
  const bgColorDark = checked ? 'purple.400' : 'gray.300';

  return (
    <Stack
      p={3}
      py={3}
      justifyContent={{
        base: 'flex-start',
        md: 'space-around',
      }}
      direction={{
        base: 'column',
        md: 'row',
      }}
      alignItems={{ md: 'center' }}
    >


      <Flex width={{ base: '100%', md: '40%' }}>
        <Heading size="md" minWidth={0} maxWidth="100%">
          {title}
        </Heading>
        {checked && ( // Render the badge if it's marked as checked
        <Badge colorScheme="green" variant="subtle" position="relative" height="18px" top="-25px" right="130px"  >
          Best Selling!
        </Badge>
      )}
      </Flex>
      <List spacing={3} textAlign="start">
        {options.map((desc) => (
          <ListItem key={desc.id}>
            <ListIcon as={FaCheckCircle} color="green.500" />
            {desc.desc}
          </ListItem>
        ))}
      </List>
      <Flex width={{ base: '100%', md: '20%' }}>
        <Heading size="xl" minWidth={0} maxWidth="100%">
          {typePlan}
        </Heading>
      </Flex>
      <Stack>
        <Button
        as={Link}
        to={productLink}
          size="md"
          color={useColorModeValue(colorTextLight, colorTextDark)}
          bgColor={useColorModeValue(bgColorLight, bgColorDark)}
        >
          Get Started
        </Button>
      </Stack>
    </Stack>
  );
};

const PricingCompo = () => {
  const [isDesktop] = useMediaQuery('(min-width: 768px)');
  return (
    <Center>
      <Box py={6} px={5} min={'100vh'} width={isDesktop ? '80%' : '100%'}>
        <Stack spacing={4} width={'100%'} direction={'column'}>
          <Stack
            p={5}
            alignItems={'center'}
            justifyContent={{
              base: 'flex-start',
              md: 'space-around',
            }}
            direction={{
              base: 'column',
              md: 'row',
            }}
          >
            <Stack
              width={{
                base: '100%',
                md: '40%',
              }}
              textAlign={'center'}
            >

              <Heading size={'lg'}>
                The Right Plan for <Text color="rgb(20, 93, 160)">Your Business</Text>
              </Heading>
            </Stack>
            <Stack
              width={{
                base: '100%',
                md: '60%',
              }}
            >
              <Text textAlign={'center'}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam
                quod in iure vero. Facilis magnam, sed officiis commodi labore
                odit.
              </Text>
            </Stack>
          </Stack>

          <PackageTier title={'General SOP'} typePlan="$15.00" options={options} checked={true} productLink="/product1"/>
          <Divider color="rgba(200, 200, 200, 8)" />
          <PackageTier
            title={'Common Essay'}
            checked={false}
            typePlan="$32.00"
            options={options}
            productLink="/product2"
          />
          <Divider color="rgba(200, 200, 200, 8)" />
          <PackageTier
            title={'LOR'}
            typePlan="$50.00"
            options={options}
            productLink="/product3"
          />
        </Stack>
      </Box>
    </Center>
  );
};

export default PricingCompo;
